// @ts-check

/** @typedef {import('@datahooks/types/tagging.types').OrganisationTag} OrganisationTag */

import React from 'react';

import { IoAddCircle } from "react-icons/io5";

import MenuLinkFiltersPopup from '@components/navigation/MenuLinkFiltersPopup';

import PropTypes from "prop-types";
import { OrganisationTagPropType } from '@datahooks/types/tagging.types.js';

/**
 * Dialog to add tags to a project
 * 
 * @param {Object} props
 * @param {number} props.projectId ID of the project to add tags to
 * @param {OrganisationTag[]} props.availableTags List of available tags to add
 * @param {any} props.existingTags List of existing tags already added to the project
 * @param {Function} props.onAdd Callback when a tag is added
 *
 * @returns JSX.Element
 */
const ProjectTagsAddDialog = ({ projectId, availableTags, existingTags, onAdd }) => {

    const addableTags = availableTags.filter(tag => {
        if (tag.multi_value) return true;

        const existingTagValues = existingTags?.filter(t => t.tag_id === tag.tag_id) || [];
        return existingTagValues.length === 0;
    });

    const tagAdded = (filter) => {
        onAdd?.({ project_id: projectId, tag_value_id: filter.value });
    }

    return (
        <MenuLinkFiltersPopup 
            onFiltered={tagAdded} 
            tags={addableTags}
            buttonLabel={<span className='flex items-center gap-x-2 p-2 text-blue-500'><IoAddCircle size={20}/> Add Tag</span>}
            triggerDisabled={addableTags.length === 0} // Disable if no tags can be added
        />
    )
}

export default ProjectTagsAddDialog;

ProjectTagsAddDialog.propTypes = {
    projectId: PropTypes.number.isRequired,
    availableTags: PropTypes.arrayOf(OrganisationTagPropType).isRequired,
    existingTags: PropTypes.object.isRequired,
    onAdd: PropTypes.func,
};